import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../client';
import { RejectionFreePageVideoResponse } from './interface';


export const getRejectionFreePageVideos = createAsyncThunk(
  'rejectionFreePageVideo/getRejectionFreePageVideos',
  async (_,
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.get<RejectionFreePageVideoResponse>(
        `/api/rejection-free-page-videos`

      );
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);


